import { Injectable } from '@angular/core';
import { ApiService } from 'app/shared/constant/api-service/api.service';
import { API_ENDPOINTS } from 'app/core/constants/api-endpoints.constant';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class InsuranceService {
    constructor(private _apiService: ApiService) {}

    getInsuranceData(): Observable<any> {
        return this._apiService.get(API_ENDPOINTS.INSURANCE);
    }
}
